import React from 'react';
import useSeo from '../../helpers/useSeo';
import './CareerPage.css'; // Assuming we're using a separate CSS file for this page

const CareerPage = () => {
  useSeo({
    title: 'Careers',
    description: 'Join Martin Advertising. We are always looking for creative thinkers and doers who want to do high-quality work that stands out.',
    path: '/careers',
  });

  return (
    <div className="career-page">
      {/* Top Section: Header and Apply Button */}
      <div className="top-section">
        <div className="left-content">
          <h1>We are Always Looking for Creative Thinkers and Doers.</h1>
        </div>
        <div className="right-content">
          <button className="apply-button" onClick={() => (window.location.href = 'mailto:bsanford@martinadvertising.com?subject=Job Application')}
          >
            <span>Click to <br /> Apply! </span>
          </button>
        </div>
      </div>

      {/* Middle Section: Paragraph */}
      <div className="middle-section">
        <p>
          Martin is for passionate, driven individuals who are eager to
          contribute to high-quality work that stands out in the advertising
          landscape. Explore our current job openings and discover how you can
          be part of a team that values creativity, trust, and a commitment to
          excellence.
        </p>
      </div>

      {/* Bottom Section: Job Openings */}
      <div className="openings-section">
        <p>No current openings are posted, but like any good team, we’re always recruiting!  Send us your resume, we’d love to chat.</p>
        
        {/* <div className="job-openings">
          <a href="/pdfs/SeniorMediaPlannerJob.pdf" className="job-button" target="_blank" rel="noopener noreferrer">
          Senior Media Planner
          </a>
           <a href="/pdfs/SeniorMediaBuyerJob.pdf" className="job-button" target="_blank" rel="noopener noreferrer">
          Senior Media Buyer
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default CareerPage;
